import React, { Suspense } from 'react';

// project import
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import DegreeDayPredictionRoutes from './DegreeDayPredictionRoutes';
import { useRoutes } from 'react-router-dom';

// componnet
import Loading from '../components/Loading'
// src\components\Loading.js
// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    const routes = useRoutes([MainRoutes, LoginRoutes, DegreeDayPredictionRoutes]);

    return (
        <Suspense fallback={
            <div 
            style={{
                position: 'fixed',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000,
                background: 'rgba(255, 255, 255, 0.3)'
            }}>
        <Loading/>
        </div>}>
            {routes}
        </Suspense>
    );
}
